export default __webpack_public_path__ + "static/media/20.305ece52.jpg";